export default "__VITE_ASSET__e9g7_t9i__"